import { useEffect, useRef } from "react";

export const GenerateCode = (props) => {
  const {code} = props;
  const canvasRef = useRef(null);

  // 生成范围随机数值
  const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  // 生成验证码
  const drawCanvasCode = (verCode) => {
    const canvas = canvasRef.current;

    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    if (!ctx) return;

    const drawWidth = canvas.width;
    const drawHeight = canvas.height;

    // 清空 Canvas
    ctx.clearRect(0, 0, drawWidth, drawHeight);
    ctx.fillStyle = "#f4f5f6";
    ctx.fillRect(0, 0, drawWidth, drawHeight);

    // 随机颜色
    const texts = verCode.split("").map((x, index) => ({
      text: x,
      color: `rgba(${getRandomInt(0, 150)}, ${getRandomInt(0, 150)}, ${getRandomInt(0, 150)}, 1)`,
    }));

    // 设置字体和基线
    const fontSize = Math.floor((drawHeight * 8) / 10);
    ctx.font = `${fontSize}px Arial`;
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";

    // 初始位置
    let x = Math.floor((drawWidth * 15) / 100);
    const y = drawHeight / 2;
    const gap = (drawWidth - x * 2) / 3;
    // 绘制每个文字
    texts.forEach(({text, color}) => {
      // 保存上下文状态
      ctx.save();
      // 设置颜色
      ctx.fillStyle = color;
      // 平移上下文到文字的绘制位置
      ctx.translate(x, y);
      // 旋转上下文
      // ctx.rotate((angle * Math.PI) / 180)
      // 绘制文字
      ctx.fillText(text, 0, 0);
      // 恢复上下文状态
      ctx.restore();
      // 更新 x 位置
      x += gap;
    });

    // 添加随机干扰点
    for (let i = 0; i < 1; i++) {
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "rgba(21, 21, 22, 0.3)";
      ctx.moveTo(getRandomInt(0, drawWidth), getRandomInt(0, drawHeight));
      ctx.lineTo(getRandomInt(30, drawWidth), getRandomInt(10, drawHeight));
      ctx.stroke();
    }
  };

  // 组件挂载时生成验证码
  useEffect(() => {
    if (!code) return;

    drawCanvasCode(String(code));
  }, [code]);

  // 设置 canvas 宽高
  useEffect(() => {
    const canvas = canvasRef.current;
    const parentWidth = canvas.parentNode.offsetWidth;
    const parentHeight = canvas.parentNode.offsetHeight;
    canvas.width = parentWidth;
    canvas.height = parentHeight;
  }, []);

  return (
    <div className="captcha-code-modal__container-content-generate-canvas">
      <canvas ref={canvasRef} />
    </div>
  );
};
